module.exports = __webpack_public_path__ + "static/whatsapp-2-c4a5c75cb0d8bb1d9d0ae42b7552ec32.png";